module.exports = __webpack_public_path__ + "static/media/car.2cf2d433.png";